import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IRole, IUser } from '../models';
import { IUserRole } from '../models/i-user-role';
import { ApiResponse, BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  GetRoles(){
    return this.http.get<ApiResponse<IRole[]>>(`${Constants.API_URL}api/Role/GetRoles`);
  }

  GetRolesByUser(User: IUser){
    return this.http.get<ApiResponse<IUserRole[]>>(`${Constants.API_URL}api/Role/GetRolesByUser?UserId=${User.Id}`);
  }

  UpdateRolesByUser(RoleIds: number[], UserId: number){
    let params = {
      RoleIds: RoleIds,
      UserId: UserId
    }
    return this.http.post<ApiResponse<any>>(`${Constants.API_URL}api/Role/UpdateRolesByUser`, params);
  }

  StoreRole(Role: IRole): Observable<BaseResponse> {
    return this.http.post<BaseResponse>(
      `${Constants.API_URL}api/Role/StoreRole`, Role)
  }

}
